import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.ruleEngine')
  .factory('ruleEngineAPI', RuleEngineAPI);

function RuleEngineAPI(): BringozApi {
  return {
    base: `/ruleengine`,
    actions: {
      getEvents: {
        address: 'eventModel',
        cmd: 'GET',
        updateable: true
      },
      getEntityFilters: {
        address: 'filterModel',
        cmd: 'GET',
        updateable: true
      },
      getEntityActions: {
        address: 'actionModel',
        cmd: 'GET',
        updateable: true
      },
      getEntitySubtypes: {
        address: 'subtypeModel',
        cmd: 'GET',
        updateable: false
      }
    }
  }
}
